module.exports = __webpack_public_path__ + "static/media/SRE007_03.cab611bf.png";